import React, { useState } from 'react';
import { BurgerMenuIconWrapper } from './styles';
import dynamic from 'next/dynamic';
import BurgerMenuIcon from '@/public/images/ackodrive/hamburger_menu.svg';
const Menu = dynamic(() => import('./Menu'), { ssr: false });

export interface hamBurgerMenu {
    margin?: string;
    toggleLogoutModal: () => void;
}

export default function HamBurgerMenu({
    margin,
    toggleLogoutModal,
}: hamBurgerMenu) {
    const [showMenuOptions, setShowMenuOptions] = useState<boolean>(false);
    const toggleMenuOptions = () => {
        showMenuOptions
            ? (document.body.style.overflow = 'auto')
            : (document.body.style.overflow = 'hidden');

        setShowMenuOptions((showMenuOptions) => !showMenuOptions);
    };

    return (
        <>
            <BurgerMenuIconWrapper
                onClick={toggleMenuOptions}
                customMargin={margin}
            >
                <BurgerMenuIcon alt="burgerMenu" />
            </BurgerMenuIconWrapper>
            {showMenuOptions && (
                <Menu
                    onClose={toggleMenuOptions}
                    onLogout={() => {
                        toggleMenuOptions();
                        toggleLogoutModal();
                    }}
                />
            )}
        </>
    );
}
